import IPostboxDelivery from '../../interfaces/postboxDelivery/postboxDelivery';

export const getPostboxDeliveryDataModel = (data: IPostboxDelivery, staffEmail: string) => {
    const model = {
        trackingnumber: data.trackingnumber,
        customerEmail: data.customerEmail,
        staffEmail: staffEmail,
        phone: data.phone,
        name: data.name,
        postbox: data.postbox,
    };

    return model;
};
